import { useEffect, useMemo, useState } from 'react';

import { SelectChangeEvent } from '@mui/material';

import {
  ExtendedChart,
  ExtendedOptions,
  ExtendedSeriesType
} from '@/components/Chart/types/highcharts';

const useLegendDropdown = ({
  chart,
  options
}: {
  chart: ExtendedChart | null;
  options: ExtendedOptions | undefined;
}) => {
  const allChartSeries = useMemo(
    () => chart?.series?.filter(series => !series.name.includes('Navigator')) ?? [],
    [chart?.series, options]
  );

  const visibleSeries = useMemo(
    () => chart?.series?.filter(series => !series.name.includes('Navigator') && series.visible),
    [chart?.series, options]
  );

  const [selectedSeries, setSelectedSeries] = useState<ExtendedSeriesType[] | undefined>();

  // Sync selected series with chart visibility when chart/options change
  useEffect(() => {
    setSelectedSeries(visibleSeries);
  }, [visibleSeries]);

  const handleLegendItemClick = (e: SelectChangeEvent<ExtendedSeriesType[]>) => {
    const value = e.target.value;
    if (typeof value === 'object') {
      chart?.series?.map(item => {
        if (value.includes(item)) {
          item.setVisible(true);
        } else {
          item.setVisible(false);
        }
      });
      setSelectedSeries(chart?.series?.filter(item => item.visible));
    }
  };

  return { selectedSeries, allChartSeries, handleLegendItemClick };
};

export default useLegendDropdown;
